import React from "react";
import {LuTrash2} from "react-icons/lu";
import "./FilterActions.css"
import DefaultDropButton from "../Buttons/DefaultDropButton/DefaultDropButton.jsx";
import {LabeledTextField} from "../Fields/LabeledTextField.jsx";
import {ActionType} from "../../utils/api-client/api.js";
import {ReplaceFieldWithStaticValueAction} from "./ReplaceFieldWithStaticValueAction.js";
import {ReplaceFieldWithFunctionAction} from "./ReplaceFieldWithFunctionAction.js";

const hideRow = "Hide Row"
const hideColumn = "Hide Column"
const renameColumn = "Rename Column"
const replaceFieldWithStaticValue = "Replace Field with Static Value"
const replaceFieldWithFunction = "Replace Field with Fake Value"
const conditionalActionValues = [hideRow, replaceFieldWithStaticValue, replaceFieldWithFunction]
const unconditionalActionValues = [hideColumn, renameColumn, replaceFieldWithStaticValue, replaceFieldWithFunction]

function HideRowAction({index, onDelete} : {
    index: number;
    onDelete: (index: number) => void;
}) {
    return <div className="action HideRow" key={index}>
        <div>Hide the entire row</div>
        <LuTrash2
            className="trash"
            onClick={() => onDelete(index)}
        />
    </div>
}

function HideColumnAction({index, fieldName, fieldNames, onFieldChange, onDelete}: {
    index: number;
    fieldName: string;
    fieldNames: string[];
    onFieldChange: (index: number, newValue: string) => void;
    onDelete: (index: number) => void;
}) {
    return <div className="action HideField" key={index}>
        <div className="condition-operator"> Hide Column </div>
        <DefaultDropButton
            name={"condition_" + index}
            options={fieldNames}
            selected={fieldName}
            onSelect={(newValue) => {
                onFieldChange(index, newValue);
            }}
            className="action-field"
            label={"Field"}
            hideLabel
            buttonText={""}
            disabled={false}
            secondary={false}
            errorLoc={[]}
        />
        <LuTrash2
            className="trash"
            onClick={() => onDelete(index)}
        />
    </div>

}

function RenameColumnAction({index, fieldName, fieldNames, value, onFieldChange, onValueChange, onDelete}: {
    index: number;
    fieldName: string;
    fieldNames: string[];
    value: string;
    onFieldChange: (index: number, newValue: string) => void;
    onValueChange: (index: number, newValue: string) => void;
    onDelete: (index: number) => void;
}) {
    return <div className="action RenameField" key={index}>
        <div className="condition-operator"> Rename field</div>
        <DefaultDropButton
            name={"condition_" + index}
            options={fieldNames}
            selected={fieldName}
            onSelect={(newValue) => {
                onFieldChange(index, newValue);
            }}
            className="action-field"
            buttonText="Select a Column"
            disabled={false}
            secondary={false}
            errorLoc={[]}
            label={""}
            hideLabel={false}
        />
        <div className="to">to</div>
        <LabeledTextField
            placeholder="(Value)"
            name={"value_" + index}
            className={"new-column-name"}
            value={value}
            onChange={(e: any) => {
                onValueChange(index, e.target.value)
            }}
        />
        <LuTrash2
            className="trash"
            onClick={() => onDelete(index)}
        />
    </div>
}

function FilterActions({actions, setActions, columnNames}: {
    actions: {
        action: string;
        field: string;
        value: string;
        value_type?: string; // For replaceFieldWithStaticValue
    }[];
    setActions: (actions: {
        action: string;
        field: string;
        value: string;
        value_Type?: string; // For replaceFieldWithStaticValue
    }[]) => void;
    columnNames: string[];
}) {

    function removeAction(index){
        const newActions = [...actions]
        newActions.splice(index, 1)
        setActions(newActions)
    }

    const actionInputs = [];
    actions.forEach((action, i) => {
        if(action.action === hideRow) {
            actionInputs.push(<HideRowAction
                key={"action_" + i}
                index={i}
                onDelete={removeAction}
            />)
        }

        if(action.action === hideColumn) {
            actionInputs.push(<HideColumnAction
                key={"action_" + i}
                index={i}
                fieldName={action.field}
                fieldNames={columnNames}
                onFieldChange={(index, newValue) => {
                    const newActions = [...actions]
                    newActions[index].field = newValue
                    setActions(newActions)
                }}
                onDelete={removeAction}
            />)
        }

        if(action.action === renameColumn) {
            actionInputs.push(<RenameColumnAction
                key={"action_" + i}
                index={i}
                fieldNames={columnNames}
                fieldName={action.field}
                value={action.value}
                onFieldChange={(index, newValue) => {
                    const newActions = [...actions]
                    newActions[index].field = newValue
                    setActions(newActions)
                }}
                onValueChange={(index, newValue) => {
                    const newActions = [...actions]
                    newActions[index].value = newValue
                    setActions(newActions)
                }}
                onDelete={removeAction}
            />)
        }

        if(action.action === replaceFieldWithStaticValue){
            actionInputs.push(<ReplaceFieldWithStaticValueAction
                key={"action_" + i}
                index={i}
                staticValueTypes={[
                    "string",
                    "integer",
                    "json",
                ]}
                selectedFieldName={action.field}
                selectedStaticValueType={action.value_type}
                value={action.value}
                fieldNames={columnNames}
                onDelete={removeAction}
                onFieldChange={(index, newValue) => {
                    const newActions = [...actions]
                    newActions[index].field = newValue
                    setActions(newActions)
                }}
                onValueTypeChange={(index, newValueType) => {
                    const newActions = [...actions]
                    newActions[index].value_type = newValueType
                    setActions(newActions)
                    if (newValueType === "json") {
                        newActions[index].value = "{}"
                    }
                }}
                onValueChange={(index, newValue) => {
                    const newActions = [...actions]
                    newActions[index].value = newValue
                    setActions(newActions)
                }}

            />)
        }

        if(action.action === replaceFieldWithFunction){
            actionInputs.push(<ReplaceFieldWithFunctionAction
                key={"action_" + i}
                index={i}
                fieldName={action.field}
                fieldNames={columnNames}
                functionName={action.value}
                functionNames={[
                    ActionType.RandomFirstname,
                    ActionType.RandomLastname,
                    ActionType.RandomName,
                    ActionType.RandomEmail,
                    ActionType.RandomPhone,
                    ActionType.RandomCountry,
                    ActionType.RandomAdministrativeArea,
                    ActionType.RandomPostalCode,
                    ActionType.RandomCity,
                    ActionType.RandomStreetAddress,
                    ActionType.RandomAddress,
                    ActionType.RandomTextLoremIpsum,
                    ActionType.RandomTextPicardIpsum,
                    ActionType.RandomIpv4Address,
                    ActionType.RandomIpv6Address,
                    ActionType.RandomLanguageName,
                    ActionType.RandomLanguageCode,
                    ActionType.RandomBoolean,
                    ActionType.RandomDate,
                ]}
                onDelete={removeAction}
                onFieldChange={(index, newValue) => {
                    const newActions = [...actions]
                    newActions[index].field = newValue
                    setActions(newActions)
                }}
                onValueChange={(index, newValue) => {
                    const newActions = [...actions]
                    newActions[index].value = newValue
                    setActions(newActions)
                }}
            />)
        }
    })

    let actionElements = <></>  //<Text className="secondary1">No actions set</Text>
    if (actionInputs.length > 0) {
        actionElements = <div className="actions">{actionInputs}</div>
    }
    return <>
        {actionElements}
    </>
}

export default FilterActions;
export {hideRow, hideColumn, renameColumn, replaceFieldWithStaticValue, replaceFieldWithFunction, conditionalActionValues, unconditionalActionValues}